import { render } from "./TheBBCActions.vue?vue&type=template&id=3a4f8cbd"
import script from "./TheBBCActions.vue?vue&type=script&lang=js"
export * from "./TheBBCActions.vue?vue&type=script&lang=js"
script.render = render

export default script